import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { isMobile } from 'react-device-detect';
import { connect } from 'react-redux';
import { getBrandConfig, getCurrentBrand } from '../../../helpers/brand';
import { MEMORY_STORE } from '../../../helpers/constants/storage';

@connect(state => ({
  local: state.local,
  // Subscribe to brand changes from Redux
  currentBrand: state.memory?.[MEMORY_STORE.CURRENT_BRAND] || getCurrentBrand(),
}))

/**
 * Renders the current logged username with picture
 */
class Logo extends Component {
  state = {};

  render() {
    if (isMobile) {
      return <></>;
    }

    // Get brand-specific logo (will re-compute when currentBrand prop changes)
    const brandConfig = getBrandConfig();
    const logoSrc = brandConfig.logoPath;
    const logoAlt = `${brandConfig.name} Logo`;
    const brandClass = brandConfig.name.toLowerCase();

    return (
      <div className={`logo-container brand-${brandClass}`}>
        <div className="logo-content">
          <p className="logo-name">
            <img src={logoSrc} alt={logoAlt} className="logo" />
          </p>
        </div>
      </div>
    );
  }
}

Logo.propTypes = {
  local: PropTypes.object,
  currentBrand: PropTypes.string,
};

export default Logo;
